import { Form, Input, InputNumber, Select } from "antd";
import SelectDownIcon from "../../assets/icons/SelectDownIcon";
import { selectSearchOption } from "../../utils/utils";

type KPIAddMoreFormProps = {
  kpiArray: string;
  kpiType: string;
  weighage: string;
  details: string;
  comment: string;
  ratingByOwn: string;
  disabled?: boolean;
  disabledLineManagerInfo?: boolean;
  hidLineManagerInfo?: boolean;
};

export default function AppraisalKPIAddMoreForm({
  kpiArray,
  kpiType,
  weighage,
  details,
  comment,
  ratingByOwn,
  disabled,
  disabledLineManagerInfo,
  hidLineManagerInfo,
}: KPIAddMoreFormProps) {
  return (
    <Form.List name={kpiArray} initialValue={[{}]}>
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => (
            <div key={field.key}>
              <div className="self-stretch px-3 py-1.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-2.5 w-full flex-wrap">
                <div className="flex justify-between items-center w-full gap-2.5">
                  <div className="text-slate-600 text-lg font-semibold">
                    KPI - {String(index + 1).padStart(2, "0")}
                  </div>

                  {/* {!disabled && fields.length > 1 && (
                    <div
                      className="cursor-pointer"
                      onClick={() => remove(field.name)}
                    >
                      <DeleteIcon color="#F05323" />
                    </div>
                  )} */}
                </div>
              </div>

              <div className="md:flex justify-between items-end mt-4">
                <div className="md:flex items-center gap-3 md:w-[75%]">
                  <Form.Item
                    name={[field.name, kpiType]}
                    label="Type KPI"
                    className="md:w-1/2"
                  >
                    <Input
                      className="w-full"
                      size="large"
                      placeholder="Enter KPI title"
                      disabled
                    />
                  </Form.Item>

                  <Form.Item
                    name={[field.name, weighage]}
                    label="Weighage (%)"
                    className="md:w-1/2"
                  >
                    <InputNumber
                      className="w-full"
                      size="large"
                      placeholder="%"
                      disabled
                    />
                  </Form.Item>
                </div>

                <div className="md:w-[25%]"></div>
              </div>

              <div className="md:flex justify-between items-end">
                <div className="md:flex items-center gap-3 md:w-[75%]">
                  <Form.Item
                    name={[field.name, details]}
                    label="Details"
                    className="w-full"
                  >
                    <Input.TextArea
                      className="w-full"
                      size="large"
                      placeholder="Enter KPI details"
                      disabled
                    />
                  </Form.Item>
                </div>

                {/* {!disabled ? (
                  <div className="md:w-[25%] md:pl-3 mb-6 text-end md:text-start">
                    {index === fields.length - 1 && (
                      <Button
                        onClick={() => add()}
                        className="h-11 px-3.5 py-2 bg-white rounded-md outline outline-1 outline-offset-[-1px] outline-orange-600 inline-flex justify-center items-center gap-2.5 overflow-hidden"
                      >
                        <div className="flex justify-center items-center gap-2">
                          <AddIcon color="#F05323" />
                          <span className="text-orange-600 text-sm font-semibold leading-normal">
                            Add More
                          </span>
                        </div>
                      </Button>
                    )}
                  </div>
                ) : null} */}
              </div>

              <div className="flex justify-between items-end">
                <div className="flex items-center gap-3 w-[75%]">
                  <Form.Item
                    name={[field.name, comment]}
                    label="Self Evaluation"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Please enter remarks",
                      },
                    ]}
                  >
                    <Input.TextArea
                      className="w-full"
                      size="large"
                      placeholder="Leave your text here"
                      disabled={disabled}
                    />
                  </Form.Item>
                </div>

                <div className="w-[25%] pl-3 mb-6">
                  <Form.Item
                    name={[field.name, ratingByOwn]}
                    label="Rating (1-10)"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Please enter rating",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      size="large"
                      allowClear
                      showSearch
                      filterOption={selectSearchOption}
                      options={ratingList}
                      suffixIcon={<SelectDownIcon />}
                      disabled={disabled}
                    />
                  </Form.Item>
                </div>
              </div>
              {!hidLineManagerInfo && (
                <div className="flex justify-between items-end">
                  <div className="flex items-center gap-3 w-[75%]">
                    <Form.Item
                      name={[field.name, "lineManagerEvaluation"]}
                      label="Line Manager Evaluation"
                      className="w-full"
                      rules={[
                        {
                          required: true,
                          message: "Please enter remarks",
                        },
                      ]}
                    >
                      <Input.TextArea
                        className="w-full"
                        size="large"
                        placeholder="Leave your text here"
                        disabled={disabledLineManagerInfo}
                      />
                    </Form.Item>
                  </div>

                  <div className="w-[25%] pl-3 mb-6">
                    <Form.Item
                      name={[field.name, "ratingByLineManager"]}
                      label="Rating (1-10)"
                      className="w-full"
                      rules={[
                        {
                          required: true,
                          message: "Please enter rating",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select"
                        size="large"
                        allowClear
                        showSearch
                        filterOption={selectSearchOption}
                        options={ratingList}
                        suffixIcon={<SelectDownIcon />}
                        disabled={disabledLineManagerInfo}
                      />
                    </Form.Item>
                  </div>
                </div>
              )}

              {/* <div className="flex justify-between items-end">
                <div className="flex items-center gap-3 w-[75%]">
                  <Form.Item
                    name={[field.name, "lineManagerEvalluation"]}
                    label="Line Manager Evaluation"
                    className="w-full"
                    //   rules={[
                    //     {
                    //       required: true,
                    //       message: "Please enter remarks",
                    //     },
                    //   ]}
                  >
                    <Input.TextArea
                      className="w-full"
                      size="large"
                      placeholder="Leave your text here"
                    />
                  </Form.Item>
                </div>

                <div className="w-[25%] pl-3 mb-6">
                  <Form.Item
                    name={[field.name, "rating"]}
                    label="Rating (1-3)"
                    className="w-full"
                    //   rules={[
                    //     {
                    //       required: true,
                    //       message: "Please enter remarks",
                    //     },
                    //   ]}
                  >
                    <Select
                      placeholder="Select"
                      size="middle"
                      allowClear
                      showSearch
                      //   filterOption={selectSearchOption}
                      //   options={selectArrayOption(
                      //     departmentData?.data?.departments || [],
                      //     "name",
                      //     "id"
                      //   )}
                      suffixIcon={<SelectDownIcon />}
                      //   loading={isDepartmentLoading}
                    />
                  </Form.Item>
                </div>
              </div> */}
            </div>
          ))}
        </>
      )}
    </Form.List>
  );
}

const ratingList = [...Array(10)].map((_, index) => ({
  label: (index + 1).toString(),
  value: index + 1,
}));
